import { FontFamily } from '@euler/components/typography/fonts';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import React, { memo, useMemo } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useInlineFormatter } from './InlineFormatter';

export const Blockquote = memo(({ lines }: { lines: string[] }) => {
  const { rpx } = useResponsiveContext();
  const renderInline = useInlineFormatter();
  const s = useMemo(
    () =>
      StyleSheet.create({
        blockquote: {
          borderLeftWidth: rpx(3),
          borderLeftColor: '#3B82F6',
          backgroundColor: '#EFF6FF',
          paddingHorizontal: rpx(12),
          paddingVertical: rpx(8),
          marginVertical: rpx(6),
          borderRadius: rpx(4),
        },
        blockquoteText: {
          fontSize: rpx(13),
          lineHeight: rpx(20),
          fontFamily: FontFamily.NotoSans.Regular,
          color: '#1E40AF',
        },
      }),
    [rpx],
  );

  return (
    <View style={s.blockquote}>
      {lines.map((line, i) => (
        <Text key={i} style={s.blockquoteText}>
          {renderInline(line)}
        </Text>
      ))}
    </View>
  );
});
